import ReactDOM from 'react-dom/client';
import App from 'App';

import 'assets/index.css';
import 'assets/tiptap.css';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'assets/ag-grid.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);
